<template>
  <v-app>
    <v-app-bar app color="orange" dark>
      <v-toolbar-title>Lumo Gas Search</v-toolbar-title>
    </v-app-bar>
    <v-content>
      <v-container fluid>
        <v-row align="center" justify="center" class="grey lighten-5">
          <v-col cols="9">
            <search-and-display />
          </v-col>
        </v-row>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import SearchAndDisplay from './components/SearchAndDisplay';
export default {
  name: 'App',

  components: {
    SearchAndDisplay,
  },

  data() {
    return {
      fullPage: false,
    };
  },
};
</script>
